import React, { lazy, Suspense } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import "@/App.css";
import { AuthProvider } from "@/context/AuthContext";
import { Toaster } from "sonner";
import Home from "@/pages/Home";
import AuthPage from "@/pages/AuthPage";
import AuthCallback from "@/pages/AuthCallback";
import { BillingGate } from "@/components/BillingGate";
const Profile = lazy(() => import("@/pages/Profile"));
const Admin = lazy(() => import("@/pages/Admin"));
import ProgramPage from "@/pages/ProgramPage";
import ResetPassword from "@/pages/ResetPassword";
import GuestbookPage from "@/pages/GuestbookPage";

function AppRouter() {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) return <AuthCallback />;
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/belepes" element={<AuthPage />} />
      <Route path="/profil" element={<Profile />} />
      <Route path="/admin" element={<Admin />} />
      <Route path="/program/:id" element={<ProgramPage />} />
      <Route path="/uj-jelszo" element={<ResetPassword />} />
      <Route path="/vendegkonyv" element={<GuestbookPage />} />
    </Routes>
  );
}

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Toaster position="top-center" richColors />
        <Suspense fallback={<div role="status" data-testid="page-loading" className="min-h-screen bg-cream px-8 pt-28 text-sm text-inkmuted">Oldal betöltése…</div>}>
          <AppRouter />
        </Suspense>
        <BillingGate />
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
